import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { FileController } from 'src/controllers/file.controller'
import { FileDto } from 'src/dto/file.dto'

const fileController = new FileController()

export function useDeleteFile(entity: string, referenceId?: string) {
  const { userFarm: farmId } = useAuth()

  return useMutation<FileDto, Error, FileDto>({
    mutationKey: ['deleteFile', entity, referenceId],
    mutationFn: (file: FileDto) => fileController.deleteFile(farmId!, entity, referenceId!, file)
  })
}
